export default "__VITE_ASSET__DgMgqefM__"